<div class="testCreation flex">
  <div
    class="testCreation-left flex flex-col"
    [ngClass]="{ hidden: isLeftSectionHidden }"
  >
    <div class="testCreation-left-header-holder flex flex-col gap-4 p-4">
      <div class="testCreation-left-header flex justify-between">
        <div
          class="d-grid align-items-center"
          [ngClass]="{
            'testCreation-left-header-title-container': selectedTestType.valid
          }"
        >
          <div class="testCreation-left-header-title">Test Creation</div>
          <mat-select
            *ngIf="selectedTestType.valid"
            class="testCreation-left-header-options-leftSection-course ml-2"
            placeholder="Course"
            [formControl]="selectedTestType"
            [disabled]="createdSections.length !== 0"
          >
            <mat-option
              *ngFor="let course of testTypesList; let courseIndex = index"
              [value]="course.testTypeId"
              >{{ course.testTypeName }}</mat-option
            >
          </mat-select>
        </div>
        <div class="flex gap-4">
          <div
            class="testCreation-left-header-actionBtns flex items-center"
            [routerLink]="'/tests'"
          >
            <mat-icon>keyboard_backspace</mat-icon>
            <span>Go back</span>
          </div>
          <div
            (click)="isLeftSectionHidden = true"
            class="testCreation-left-header-actionBtns flex items-center"
          >
            << Collapse
          </div>
        </div>
      </div>
      <div
        class="testCreation-left-header-options-leftSection flex justify-between items-center"
      >
        <div class="flex gap-4">
          <mat-select
            *ngIf="selectedTestType.invalid"
            class="testCreation-left-header-options-leftSection-course"
            placeholder="Course"
            [formControl]="selectedTestType"
            [disabled]="createdSections.length !== 0"
          >
            <mat-option
              *ngFor="let course of testTypesList; let courseIndex = index"
              [value]="course.testTypeId"
              >{{ course.testTypeName }}</mat-option
            >
          </mat-select>
          <div class="" *ngIf="selectedTestType.valid">
            <input
              placeholder="Test ID"
              [formControl]="testId"
              (keyup)="checkValidity()"
              class="testCreation-left-header-options-leftSection-input"
              [ngClass]="{
                'testCreation-left-header-options-leftSection-input-error':
                  (testId.touched && testId.invalid) ||
                  (testId.invalid &&
                    createdSections.length > 0 &&
                    isSaveClicked)
              }"
            />
          </div>
          <div class="">
            <input
              placeholder="Name of the Test"
              [(ngModel)]="testName"
              class="testCreation-left-header-options-leftSection-input"
            />
          </div>
        </div>
        <div
          class="testCreation-left-header-options-rightSection flex justify-between items-center"
          [ngClass]="{
            'testCreation-left-header-options-rightSection-invalid':
              selectedTestType.invalid
          }"
          (click)="addSection()"
        >
          <div>Add a Section</div>
          <mat-icon>add_circle_outline</mat-icon>
        </div>
      </div>
    </div>
    <div class="testCreation-left-sections px-4 py-8" cdkScrollable>
      <div
        class="testCreation-left-section flex flex-col gap-4"
        cdkDropList
        (cdkDropListDropped)="drop($event, 0, 'section')"
      >
        <div
          *ngFor="
            let createdSection of createdSections;
            let createdSectionIndex = index
          "
          cdkDrag
          cdkDragLockAxis="y"
          cdkDragBoundary=".testCreation-left-section"
          class="flex flex-col gap-4"
        >
          <div class="testCreation-left-section-top flex justify-between">
            <div class="testCreation-left-section-top-info flex gap-4">
              <input
                class="testCreation-left-section-top-info-sectionTitle flex items-center"
                [ngClass]="{
                  'testCreation-left-section-top-info-sectionTitle-invalid':
                    createdSection.sectionName === ''
                }"
                [(ngModel)]="createdSection.sectionName"
                (keyup)="checkValidity()"
              />
              <mat-select
                class="testCreation-left-section-top-info-sectionType"
                [(value)]="createdSection.sectionType"
                placeholder="Scoring Section"
                (selectionChange)="
                  getSubTopicsByScoringAndTestId(createdSectionIndex, false)
                "
              >
                <mat-option
                  *ngFor="
                    let scoringSection of scoringSectionsList;
                    let scoringSectionIndex = index
                  "
                  [value]="scoringSection.scoring_section_type_id"
                  >{{ scoringSection.scoring_section_name }}</mat-option
                >
              </mat-select>
            </div>
            <div class="flex gap-4">
              <div
                class="testCreation-left-section-top-info-sectionQuestionsCount flex items-center gap-4"
                [ngClass]="{
                  'testCreation-left-section-top-info-sectionQuestionsCount-invalid':
                    createdSection.questionTypeCount.totalQuestions !==
                      createdSection.questionTypeCount.generatedQuestions ||
                    createdSection.questionTypeCount.deletedQuestions > 0
                }"
              >
                <div
                  class="testCreation-left-section-top-info-sectionQuestionsCount-totalQuestions flex flex-col"
                >
                  <div
                    class="testCreation-left-section-top-info-sectionQuestionsCount-totalQuestions-title"
                  >
                    Total
                  </div>
                  <div class="flex justify-center">
                    <div
                      class="testCreation-left-section-top-info-sectionQuestionsCount-totalQuestions-count flex justify-center"
                    >
                      {{ createdSection.questionTypeCount.totalQuestions }}
                    </div>
                  </div>
                </div>
                <div
                  class="testCreation-left-section-top-info-sectionQuestionsCount-generatedQuestions flex flex-col"
                >
                  <div
                    class="testCreation-left-section-top-info-sectionQuestionsCount-generatedQuestions-title"
                  >
                    Generated
                  </div>
                  <div class="flex justify-center">
                    <div
                      class="testCreation-left-section-top-info-sectionQuestionsCount-generatedQuestions-count flex justify-center"
                    >
                      {{ createdSection.questionTypeCount.generatedQuestions }}
                    </div>
                  </div>
                </div>
                <div
                  class="testCreation-left-section-top-info-sectionQuestionsCount-deletedQuestions flex flex-col"
                >
                  <div
                    class="testCreation-left-section-top-info-sectionQuestionsCount-deletedQuestions-title"
                  >
                    Deleted
                  </div>
                  <div class="flex justify-center">
                    <div
                      class="testCreation-left-section-top-info-sectionQuestionsCount-deletedQuestions-count flex justify-center"
                    >
                      {{ createdSection.questionTypeCount.deletedQuestions }}
                    </div>
                  </div>
                </div>
              </div>
              <div class="testCreation-left-section-top-options flex">
                <mat-icon
                  cdkDragHandle
                  class="self-center testCreation-left-section-top-options-delete"
                  >drag_handle</mat-icon
                >
                <!-- <div
                  (click)="
                    createdSectionIndex + 1 < createdSections.length
                      ? changeCreatedSectionPosition(false, createdSectionIndex)
                      : false
                  "
                  [ngStyle]="{
                    cursor:
                      createdSectionIndex + 1 < createdSections.length
                        ? 'pointer'
                        : 'not-allowed'
                  }"
                >
                  <img
                    class="testCreation-left-section-top-options-optionDown"
                    src="assets/images/test-creation/down-arrow.svg"
                  />
                </div>
                <div
                  (click)="
                    createdSectionIndex - 1 >= 0
                      ? changeCreatedSectionPosition(true, createdSectionIndex)
                      : false
                  "
                  [ngStyle]="{
                    cursor:
                      createdSectionIndex - 1 >= 0 ? 'pointer' : 'not-allowed'
                  }"
                >
                  <img
                    class="testCreation-left-section-top-options-optionUp"
                    src="assets/images/test-creation/down-arrow.svg"
                  />
                </div> -->
                <mat-icon
                  class="self-center testCreation-left-section-top-options-delete"
                  (click)="
                    removeSectionOrQuestion(createdSectionIndex, -1, false)
                  "
                  >delete</mat-icon
                >
              </div>
            </div>
          </div>
          <div
            class="testCreation-left-section-middle-holder flex flex-col gap-4 px-1 pb-1"
          >
            <mat-checkbox
              [(ngModel)]="createdSection.breakAfterModule"
              (change)="
                createdSection.breakDuration === '0 mins' &&
                createdSection.breakAfterModule
                  ? (createdSection.breakDuration = '10 mins')
                  : (createdSection.breakDuration = '0 mins');
                createdSection.isBreakDurationValid =
                  createdSection.breakAfterModule;
                checkValidity()
              "
              class="testCreation-left-section-middle-checkbox"
              >Break - (<b>{{
                createdSection.breakAfterModule ? "Allowed" : "Not allowed"
              }}</b
              >)</mat-checkbox
            >
            <mat-checkbox
              [(ngModel)]="createdSection.canBePaused"
              class="testCreation-left-section-middle-checkbox"
              >Pause - (<b>{{
                createdSection.canBePaused ? "Allowed" : "Not allowed"
              }}</b
              >)</mat-checkbox
            >
          </div>
          <div
            class="testCreation-left-section-bottom-holder flex justify-between"
          >
            <div class="flex gap-4">
              <div
                class="testCreation-left-section-bottom-input-holder flex flex-col gap-4"
              >
                <div class="testCreation-left-section-bottom-input-heading">
                  Total Duration
                </div>
                <input
                  [id]="'totalDuration-' + createdSectionIndex"
                  class="testCreation-left-section-bottom-input-field"
                  (focus)="changeDurationText(true, true, createdSectionIndex)"
                  (focusout)="
                    changeDurationText(false, true, createdSectionIndex)
                  "
                  (input)="
                    checkInputValidity($event, createdSectionIndex, true)
                  "
                  [ngClass]="{
                    'testCreation-left-section-bottom-input-field-invalid':
                      !createdSection.isTotalDurationValid
                  }"
                  [value]="createdSection.totalDuration"
                />
              </div>
              <div
                class="testCreation-left-section-bottom-input-holder flex flex-col gap-4"
              >
                <div class="testCreation-left-section-bottom-input-heading">
                  Break Duration
                </div>
                <input
                  [disabled]="!createdSection.breakAfterModule"
                  [id]="'breakDuration-' + createdSectionIndex"
                  (focus)="changeDurationText(true, false, createdSectionIndex)"
                  (focusout)="
                    changeDurationText(false, false, createdSectionIndex)
                  "
                  (input)="
                    checkInputValidity($event, createdSectionIndex, false)
                  "
                  [ngClass]="{
                    'testCreation-left-section-bottom-input-field-invalid':
                      createdSection.breakAfterModule &&
                      !createdSection.isBreakDurationValid
                  }"
                  class="testCreation-left-section-bottom-input-field"
                  [value]="createdSection.breakDuration"
                />
              </div>
            </div>
            <div
              class="testCreation-left-section-bottom-btns-holder flex flex-col gap-4"
            >
              <div
                class="flex items-end justify-center cursor-pointer"
                [ngClass]="{
                  'cursor-not-allowed':
                    createdSection.generatedQuestions.length <= 0
                }"
              >
                <div
                  class="testCreation-left-section-bottom-regenerateBtn flex gap-2 items-center"
                  (click)="regenerateQuestions(createdSectionIndex)"
                  [ngClass]="{
                    'testCreation-left-section-bottom-regenerateBtn-invalid':
                      createdSection.generateQuestionsStructPerModule!
                        .length === 0
                  }"
                >
                  <span>Regenerate </span>
                  <mat-icon>shuffle</mat-icon>
                </div>
              </div>
              <div
                class="flex items-end"
                (click)="openQuestionDistributionPattern(createdSectionIndex)"
              >
                <div
                  class="testCreation-left-section-bottom-questionDistributionBtn flex gap-2 items-center"
                  [ngClass]="{
                    'testCreation-left-section-bottom-questionDistributionBtn-invalid':
                      createdSections[createdSectionIndex].sectionType ===
                      'scoringSection'
                  }"
                >
                  <span>Question Distribution Pattern</span>
                  <mat-icon>grid_on</mat-icon>
                </div>
              </div>
            </div>
          </div>
          <mat-divider></mat-divider>
        </div>
      </div>
    </div>
    <!-- <div class="testCreation-left-footer">
      <div
        class="testCreation-left-footer-generateButton flex justify-center"
        (click)="generateQuestionsAPI()"
      >
        <span>Generate Questions ></span>
      </div>
    </div> -->
  </div>
  <div
    class="testCreation-right"
    [ngStyle]="{ width: isLeftSectionHidden ? '100%' : '60%' }"
  >
    <div class="testCreation-right-holder flex flex-col p-4">
      <div class="flex gap-8">
        <div class="testCreation-right-title">Test Questions Generated</div>
        <div
          *ngIf="isLeftSectionHidden"
          class="testCreation-left-header-actionBtns flex items-center gap-2"
          (click)="isLeftSectionHidden = false"
        >
          <mat-icon>input</mat-icon>
          <span>Expand</span>
        </div>
      </div>
      <div
        *ngIf="createdSections.length <= 0"
        class="testCreation-right-noQuestions flex flex-col justify-center"
      >
        <div class="flex flex-col items-center">
          <span>In the left-bar</span>
          <span>1. Create sections, Select the time and distribution</span>
          <span
            >2. Then click on the "Generate Questions" to view the questions
            list here</span
          >
        </div>
      </div>
      <div>
        <mat-tab-group
          [(selectedIndex)]="currentSection"
          (selectedTabChange)="loadTikz()"
          mat-stretch-tabs="false"
          mat-align-tabs="start"
          class="testCreation-right-tabs pt-9"
        >
          <mat-tab
            *ngFor="
              let section of createdSections;
              let sectionIndex = index;
              trackBy: trackByIndexFn
            "
            [label]="section.sectionName"
          >
            <!-- {{ print(generatedModule) }} -->
            <div
              *ngIf="currentSection === sectionIndex"
              cdkDropList
              (cdkDropListDropped)="drop($event, sectionIndex, 'question')"
              [cdkDropListAutoScrollDisabled]="false"
              [cdkDropListAutoScrollStep]="20"
              class="testCreation-right-questions"
            >
              <div
                *ngIf="
                  section.generatedQuestions.length <= 0 && !generatingQuestions
                "
                class="testCreation-right-noQuestions flex flex-col justify-center"
                style="height: 70vh !important"
              >
                <div class="flex flex-col items-center">
                  <span>In the left-bar</span>
                  <span
                    >1. Create sections, Select the time and distribution</span
                  >
                  <span
                    >2. Then click on the "Generate Questions" to view the
                    questions list here</span
                  >
                </div>
              </div>
              <div
                *ngIf="
                  section.generatedQuestions.length <= 0 && generatingQuestions
                "
                class="testCreation-right-noQuestions-loading flex flex-col justify-center"
                style="height: 70vh !important"
              >
                <div class="flex flex-col items-center">
                  <span>Loading questions ... </span>
                </div>
              </div>
              <!-- {{ print(section.generatedQuestions) }} -->
              <div
                *ngFor="
                  let generatedQuestionsObj of section.generatedQuestions;
                  let generatedQuestionsObjIndex = index
                "
                cdkDrag
                cdkDragLockAxis="y"
                cdkDragBoundary=".testCreation-right-questions"
              >
                <div class="flex justify-between py-4">
                  <!-- ** Serial number and questions holder (first section of flex) -->
                  <div class="flex gap-6 w-4/5">
                    <!-- ** Question serial number -->
                    <div class="testCreation-right-questions-serialNo">
                      {{ generatedQuestionsObjIndex + 1 }}.
                    </div>
                    <!-- ** Questions -->
                    <div
                      class="testCreation-right-questions-middleSection flex flex-col gap-4 justify-between w-full"
                    >
                      <div
                        *ngFor="
                          let generatedQuestionObj of generatedQuestionsObj
                            .questionDetails.question.questionData;
                          let generatedQuestionObjIndex = index
                        "
                      >
                        <app-multi-data
                          class="testCreation-right-questions-question"
                          [multiData]="{
                            type: generatedQuestionObj.type,
                            data: generatedQuestionObj.data,
                            tikzId:
                              'generatedQuestion-' +
                              sectionIndex +
                              '-' +
                              generatedQuestionsObjIndex +
                              '-' +
                              generatedQuestionObjIndex,
                            imageKeys: generatedQuestionObj.images!,
                            listOfImages: images
                          }"
                        ></app-multi-data>
                      </div>
                      <!-- ** Choices (MCQ's) - Question type = 1 -->
                      <div
                        *ngIf="
                          generatedQuestionsObj.questionDetails.question
                            .questionType === 1
                        "
                        class="flex flex-col gap-4"
                      >
                        <div
                          *ngFor="
                            let generatedChoices of generatedQuestionsObj
                              .questionDetails.choices;
                            let generatedChoiceIndex = index
                          "
                          class="flex items-center gap-2"
                        >
                          <div
                            class="testCreation-right-choices-option"
                            [ngClass]="{
                              'self-start':
                                generatedChoices.optionValue.length > 1
                            }"
                          >
                            {{ getOptionText(generatedChoiceIndex) }})
                          </div>

                          <div class="flex flex-col gap-4">
                            <div
                              *ngFor="
                                let choiceData of generatedChoices.optionValue;
                                let choiceDataIndex = index
                              "
                            >
                              <app-multi-data
                                class="testCreation-right-choices-optionText"
                                [multiData]="{
                                  type: choiceData.type,
                                  data: choiceData.data,
                                  tikzId:
                                    'generatedChoiceOption-' +
                                    sectionIndex +
                                    '-' +
                                    generatedQuestionsObjIndex +
                                    '-' +
                                    generatedChoiceIndex +
                                    '-' +
                                    choiceDataIndex,
                                  imageKeys: choiceData.images!,
                                  listOfImages: images
                                }"
                              ></app-multi-data>
                            </div>
                          </div>
                        </div>
                      </div>
                      <!-- ** Answers (Freeetext) - Question type = 2 -->
                      <div
                        *ngIf="
                          generatedQuestionsObj.questionDetails.question
                            .questionType === 2
                        "
                      >
                        <div
                          class="flex gap-2 testCreation-right-possibilities"
                        >
                          <span><b>Answers : </b></span>
                          <span>
                            {{
                              generatedQuestionsObj.questionDetails.answers
                                ?.posibilities &&
                              (generatedQuestionsObj.questionDetails.answers
                                ?.posibilities)!.length > 0
                                ? generatedQuestionsObj.questionDetails.answers?.posibilities?.join(
                                    ", "
                                  )
                                : "N/A"
                            }}
                          </span>
                        </div>
                      </div>
                      <!-- ** Last section in questions section (for displaying answers, tags and other info)  -->
                      <div class="flex items-end justify-between">
                        <div
                          *ngFor="
                            let generatedChoices of generatedQuestionsObj
                              .questionDetails.choices;
                            let generatedChoicesIndex = index
                          "
                          [ngClass]="{ hidden: !generatedChoices.isAnswer }"
                        >
                          <div
                            *ngIf="generatedChoices.isAnswer"
                            class="flex testCreation-right-correctOption items-end"
                          >
                            <span class="testCreation-right-correctOption-text"
                              >Correct Option:&nbsp;
                            </span>
                            <span
                              class="testCreation-right-correctOption-option"
                            >
                              {{ this.options[generatedChoicesIndex] }}</span
                            >
                          </div>
                        </div>
                        <div class="testCreation-right-tags">
                          Tags:
                          {{
                            generatedQuestionsObj.questionDetails.question.tags
                              .length > 0
                              ? generatedQuestionsObj.questionDetails.question.tags.join(
                                  ", "
                                )
                              : "N/A"
                          }}
                        </div>
                        <div class="flex flex-col testCreation-right-subTopic">
                          <div class="testCreation-right-subTopic-title">
                            Sub Topic
                          </div>
                          <div class="testCreation-right-subTopic-name">
                            {{ generatedQuestionsObj.subTopicName }}
                          </div>
                        </div>
                        <div
                          class="flex flex-col testCreation-right-difficulty"
                        >
                          <div class="testCreation-right-difficulty-title">
                            Difficulty
                          </div>
                          <div
                            class="testCreation-right-difficulty-name capitalize"
                          >
                            {{
                              this.difficultyLevels[
                                generatedQuestionsObj.difficultLevel - 1
                              ].name
                            }}
                          </div>
                        </div>
                        <div
                          class="testCreation-right-questionType testCreation-right-questionType-mcq"
                          [ngClass]="{
                            'testCreation-right-questionType-freetext':
                              generatedQuestionsObj.questionDetails.question
                                .questionType === 2
                          }"
                        >
                          {{
                            generatedQuestionsObj.questionDetails.question
                              .questionType === 1
                              ? "MCQ"
                              : "Freetext"
                          }}
                        </div>
                      </div>
                    </div>
                  </div>
                  <!-- ** Config buttons (last section of flex) -->
                  <div class="flex flex-col gap-2">
                    <!-- ** Buttons for changing position -->
                    <div
                      class="testCreation-right-configOptions-option flex justify-end"
                    >
                      <mat-icon cdkDragHandle>drag_handle</mat-icon>
                      <!-- <div
                          [ngStyle]="{
                            cursor:
                              generatedQuestionsObjIndex + 1 <
                              section.generatedQuestions.length
                                ? 'pointer'
                                : 'not-allowed'
                          }"
                          (click)="
                            generatedQuestionsObjIndex + 1 <
                            section.generatedQuestions.length
                              ? changeQuestionPosition(
                                  false,
                                  sectionIndex,
                                  generatedQuestionsObjIndex
                                )
                              : false
                          "
                        >
                          <img
                            class="testCreation-right-configOptions-positionOptions-optionDown"
                            src="assets/images/test-creation/down-arrow-black.svg"
                          />
                        </div>
                        <div
                          [ngStyle]="{
                            cursor:
                              generatedQuestionsObjIndex - 1 >= 0
                                ? 'pointer'
                                : 'not-allowed'
                          }"
                          (click)="
                            generatedQuestionsObjIndex - 1 >= 0
                              ? changeQuestionPosition(
                                  true,
                                  sectionIndex,
                                  generatedQuestionsObjIndex
                                )
                              : false
                          "
                        >
                          <img
                            class="testCreation-right-configOptions-positionOptions-optionUp"
                            src="assets/images/test-creation/down-arrow-black.svg"
                          />
                        </div> -->
                    </div>
                    <!-- ** Auto replace -->
                    <div
                      class="testCreation-right-configOptions-option flex justify-center items-center"
                      (click)="
                        autoReplaceCaller(
                          sectionIndex,
                          generatedQuestionsObjIndex
                        )
                      "
                    >
                      <!-- <div>Auto Replace</div> -->
                      <mat-icon [matTooltip]="'Auto Replace'"
                        >autorenew</mat-icon
                      >
                    </div>
                    <!-- ** Manual Replace -->
                    <div
                      class="testCreation-right-configOptions-option flex justify-center items-center"
                      (click)="
                        manualReplace(sectionIndex, generatedQuestionsObjIndex)
                      "
                    >
                      <!-- <div>Manual Replace</div> -->
                      <mat-icon [matTooltip]="'Manual Replace'"
                        >find_replace</mat-icon
                      >
                    </div>
                    <div
                      class="flex testCreation-right-configOptions-option flex justify-center items-center"
                      (click)="
                        removeSectionOrQuestion(
                          sectionIndex,
                          generatedQuestionsObjIndex,
                          true
                        )
                      "
                    >
                      <!-- <div>Remove</div> -->
                      <mat-icon [matTooltip]="'Delete'">close</mat-icon>
                    </div>
                  </div>
                </div>
                <mat-divider
                  class="testCreation-right-questions-divider"
                ></mat-divider>
              </div>
            </div>
          </mat-tab>
        </mat-tab-group>
        <!-- </div> -->
      </div>
      <!-- </div> -->
    </div>
    <div class="testCreation-right-footer flex justify-end items-center px-8">
      <div
        class="testCreation-right-footer-saveBtn flex items-center justify-center"
        (click)="finalSave()"
        [ngClass]="{
          'testCreation-right-footer-saveBtn-invalid':
            !isValidQuesstionaire || !isSaveValid || createdSections.length <= 0
        }"
      >
        {{ recievedTestId > 0 && recievedTest ? "Update" : "Save" }}
      </div>
    </div>
  </div>
</div>
<p-dialog
  [(visible)]="isDataLoading"
  [modal]="true"
  [blockScroll]="true"
  [closeOnEscape]="true"
  [closable]="true"
  [showHeader]="false"
  appendTo="body"
  contentStyleClass="loader flex justify-center"
  styleClass="loaderContainer"
>
  <!-- <mat-spinner>Please wait</mat-spinner> -->
  <p-progressSpinner strokeWidth="4"></p-progressSpinner>
</p-dialog>
<p-dialog
  [(visible)]="showDuplicatesPopup"
  [modal]="true"
  [blockScroll]="true"
  [closeOnEscape]="true"
  [closable]="true"
  [showHeader]="true"
  [header]="'Questions Repeated'"
  appendTo="body"
  contentStyleClass="flex font-mont"
  styleClass="loaderContainer"
>
  <!-- <mat-spinner>Please wait</mat-spinner> -->
  <div class="testCreation-duplicatePopup flex flex-col gap-8 w-full">
    <div>
      Repeated Questions are present. Please refer the below table for more
      details.
    </div>
    <!-- <div *ngIf="duplicateQuestions.length > 0">
      <b>{{ duplicateQuestions.join(", ") }}</b>
      {{
        duplicateQuestions.length > 1
          ? "are the repeated question ID's"
          : "is the repeated question ID"
      }}
      . Please <b>Cancel</b> or <b>Proceed to save</b>
    </div> -->
    <div class="flex justify-center w-full">
      <div class="testCreation-duplicatePopup-table-holder">
        <table class="testCreation-duplicatePopup-table">
          <thead class="testCreation-duplicatePopup-table-header">
            <td class="testCreation-duplicatePopup-table-header-heading">
              Question ID
            </td>
            <td class="testCreation-duplicatePopup-table-header-heading">
              Question Position
            </td>
            <td class="testCreation-duplicatePopup-table-header-heading">
              Repeated in
            </td>
            <td class="testCreation-duplicatePopup-table-header-heading">
              Scoring Section
            </td>
          </thead>
          <tbody class="testCreation-duplicatePopup-table-body">
            <tr
              *ngFor="let duplicateQuestionInfo of duplicateQuestions"
              class="testCreation-duplicatePopup-table-body-row"
            >
              <td class="testCreation-duplicatePopup-table-body-row-value">
                {{ duplicateQuestionInfo.questionId }}
              </td>
              <td class="testCreation-duplicatePopup-table-body-row-value">
                {{ duplicateQuestionInfo.questionIdIndex + 1 }}
              </td>
              <td class="testCreation-duplicatePopup-table-body-row-value">
                {{ duplicateQuestionInfo.moduleName }}
              </td>
              <td class="testCreation-duplicatePopup-table-body-row-value">
                {{ duplicateQuestionInfo.scoringSectionName }}
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
    <div class="flex justify-end">
      <div class="flex gap-8">
        <span
          class="testCreation-duplicatePopup-btns-btn testCreation-duplicatePopup-btns-btn-cancel"
          (click)="isDuplicateSaveAllowed = false; showDuplicatesPopup = false"
          >Cancel</span
        >
        <span
          class="testCreation-duplicatePopup-btns-btn testCreation-duplicatePopup-btns-btn-proceed"
          (click)="
            isDuplicateSaveAllowed = true;
            finalSave();
            showDuplicatesPopup = false
          "
          >Proceed</span
        >
      </div>
    </div>
  </div>
</p-dialog>
